import SettingsIcon from '@mui/icons-material/Settings'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(duration)
dayjs.extend(timezone)
import { useContext, useEffect, useRef, useState } from 'react'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { buildWellnessTilePath } from 'src/consumer/helpers/wellnessRoutes'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { supportedDailyPlayItems } from 'src/consumer/constants'
import { CongratulatoryCardContext } from 'src/consumer/context/CongraulatoryCardContext'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import {
  itemDataExtractor,
  markCompleteIfPlayed,
  progressOfActiveDayProvider,
  scoreCalculator,
} from 'src/consumer/helpers/dailyPlayHelper'
import { mediaURL } from 'src/consumer/services'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { postData } from 'src/consumer/services/profileService'
import {
  BottomTextComponent,
  CardItem,
  CardItemMood,
  CompletedCardItem,
  DailyPlaySettingsComponent,
  DailyPlaySettingsModalComponent,
  DetailedOverview,
  ScoreInfo,
  SentinelItem,
  SlotEndsIn,
  SlotSummary,
  SlotTime,
  SocialComparison,
  StreakComponent,
  UnlockingTimeClock,
  cleanDataFunction,
} from './DailyPlayComponents'
import {
  ActiveCardContainer,
  BrowseAppButton,
  CardBody,
  CardHeader,
  CheatDayCard,
  CheatDayImage,
  ClosedCardImgAndText,
  CongratulatingCard,
  CongratulatingCardMaskot,
  CongratulatingCardTitle,
  DailyPlayContainer,
  DailyPlaySettingsDrawer,
  DotForCard,
  IconImage,
  LeftSideCard,
  MoreItemsButton,
  NoActiveCardItemsContainer,
  NoActiveCardItemsPicture,
  NoActiveCardText,
  PreferencesButton,
  RightSideCard,
  SlotCardsParent,
  SuggestionCard,
  SuggestionCardText,
  ThreadAndCardContainer,
  ThreadAndFlagContainer,
  ThreadForCard,
} from './DailyPlayStyles'
import isEqual from 'lodash/isEqual'
import restHammock from 'src/assets/rest_hammock.png'
import smile_emoji_play from 'src/assets/smile_emoji_play.png'
import resting_on_sofa from 'src/assets/resting_on_sofa.png'

const DailyPlay = (props) => {
  const { cardsData, extraData } = props

  // preparing data
  const daysData = {}
  const nowDate = dayjs().startOf('day')
  extraData?.forEach((card) => {
    const refDate = dayjs(card?.dailyFeature?.item?.startTime).startOf('day')
    const daysDifferenceString = refDate.diff(nowDate, 'days')?.toString()
    if (daysDifferenceString in daysData) {
      daysData[daysDifferenceString] = [...daysData[daysDifferenceString], card]
    } else {
      daysData[daysDifferenceString] = [card]
    }
  })
  daysData['0'] = cardsData
  //preparing data

  const dfidArray = []
  const [currentTime, setCurrentTime] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'))
  const outletContext = useOutletContext()
  const {
    selectedTileId: activeTile,
    timeSlotsData: timeSlots,
    completionData: completionDataFromContext,
    userScoreData,
    updateUserScoreData,
  } = outletContext
  const { setupData } = useContext(SetupContext)
  const { congratulatoryCardData } = useContext(CongratulatoryCardContext)
  const { profileData, setProfileData } = useContext(ProfileContext)
  const cardScrollRef = useRef(null)
  const [cardScrolled, setCardScrolled] = useState()
  const navigate = useNavigate()
  const [completionData, setCompletionData] = useState([...completionDataFromContext])
  const [progressActiveDay, setProgressActiveDay] = useState(null)
  const [isDailyPlaySettingsOpen, setIsDailyPlaySettingsOpen] = useState(false)
  const [userPlayConfig, setUserPlayConfig] = useState(profileData?.playConfig || {})
  const [chosenDay, setChosenDay] = useState('0')

  // for daily play settings
  let dailyPlaySettingsShowingMethod
  if (setupData?.clientType === 'mobileBrowser') {
    dailyPlaySettingsShowingMethod = 'drawer'
  } else {
    dailyPlaySettingsShowingMethod = 'modal'
  }
  const dailyPlayContentTypes = cleanDataFunction(setupData?.metaPlayConfig?.contentTypes, 'id')
  const dailyPlayContentTypesSectionWise = Object.values(
    dailyPlayContentTypes?.reduce((acc, item) => {
      item?.sectionIds?.forEach((sectionId) => {
        if (!acc[sectionId]) {
          acc[sectionId] = { sectionId, items: [] }
        }
        acc[sectionId].items.push(item)
      })
      return acc
    }, {}),
  )
  const saveDailyPlaySettings = async () => {
    setIsDailyPlaySettingsOpen(false)
    await postData('/api/secure/user/play-preferences/save', userPlayConfig)
    if (!isEqual(userPlayConfig, profileData?.playConfig)) {
      window.location.reload()
    }
    // const resp = await getData('/api/secure/user/profile')
    // if (resp?.status === 200) {
    //     setProfileData(resp?.data)
    // }
  }
  // for daily play settings

  daysData[chosenDay]?.forEach((card) => {
    dfidArray?.push(card?.dailyFeature?.item?.id)
  }) //making dailyfeatureID array, not being used now

  async function getDailyPlayProgress() {
    const response = await getDataWithoutParams(
      `/api/secure/user/daily-play-streaks?zoneOffset=${encodeURIComponent(getTimezoneOffset())}`,
    )
    if (response.status === 200) {
      setCompletionData(response?.data)
    }
  }

  useEffect(() => {
    if (congratulatoryCardData?.showCard) {
      getDailyPlayProgress()
      updateUserScoreData()
    }
  }, [congratulatoryCardData]) //setting completion data

  useEffect(() => {
    const progressOfActiveDay = progressOfActiveDayProvider(completionData, chosenDay)
    setProgressActiveDay(progressOfActiveDay)
  }, [completionData, chosenDay])

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs().format('YYYY-MM-DD HH:mm:ss'))
    }, 1000)

    return () => clearInterval(interval)
  }, []) //setting time every second

  if (currentTime === '00:00:00') {
    window.location.reload()
  } //reloading page midnight

  const supportedPlayItems = supportedDailyPlayItems //supported items

  const completionDataMap = new Map()
  progressActiveDay?.forEach((item, index) => {
    completionDataMap.set(item?.dailyFeatureId, item?.progress)
  }) //map of completion data from dfid to progress

  let allAvailableCards = []

  daysData[chosenDay]?.forEach((card) => {
    if (card.dailyFeature.item.heroItem) {
      card.dailyFeature.item.heroItem['dfid'] = card?.dailyFeature?.item?.id
    }
    card?.dailyFeature?.item?.otherItems?.forEach((otheritem) => {
      otheritem['dfid'] = card?.dailyFeature?.item?.id
    })
  }) //putting daily feature id inside heroitem and otheritems

  daysData[chosenDay].forEach((card, index) => {
    allAvailableCards.push(card?.dailyFeature?.item)
  }) //all available cards like morning, evening, fullday, etc pushed to array

  function compareStartTime(a, b) {
    let startTimeA = dayjs(a?.startTime, 'YYYY-MM-DD HH:mm:ss')
    let startTimeB = dayjs(b?.startTime, 'YYYY-MM-DD HH:mm:ss')

    if (startTimeA.isBefore(startTimeB)) return -1
    if (startTimeA.isAfter(startTimeB)) return 1
    return 0
  } //card comparison function based on startTime

  allAvailableCards.sort(compareStartTime) //sorting received cards

  const timeSlotsMap = new Map()
  if (Array.isArray(timeSlots)) {
    timeSlots?.forEach((slot, index) => {
      timeSlotsMap.set(slot?.id, slot)
    })
  } // map from timeslotid to timeslotobject. example : noon to noon_object

  allAvailableCards.forEach((card, index) => {
    let cardTimingData = timeSlotsMap.get(card?.timeSlot)
    card['slotTitle'] = cardTimingData?.title
    card['playTitle'] = cardTimingData?.playTitle
    card['iconId'] = cardTimingData?.iconId || ''
    card['emptySlotMsg'] = cardTimingData?.emptySlotMsg || {}
    // card["sentinelCard"] = cardTimingData?.sentinelCard || {};
    // card["completedSlotMsg"] = cardTimingData?.completedSlotMsg || {};
  }) // added title, timeslotimage, etc to cards data

  let fullDayCardArray = []
  if (allAvailableCards.length > 1) {
    allAvailableCards.forEach((card, index) => {
      if (card.timeSlot === 'fullday') {
        fullDayCardArray = allAvailableCards.splice(index, 1)
      }
    })
  } // fulldaycard removed, and stored if other cards are available

  let previousCards = []
  let activeCards = [...fullDayCardArray]
  let nextCards = []
  let cardStatus = '' // will carry active, prev, or next

  function cardStatusFinder(currentTime, startTime, endTime) {
    const startMoment = dayjs(startTime, 'YYYY-MM-DD HH:mm:ss')
    const currentMoment = dayjs(currentTime, 'YYYY-MM-DD HH:mm:ss').add(parseInt(chosenDay), 'day')
    const endMoment = dayjs(endTime, 'YYYY-MM-DD HH:mm:ss')

    if (startMoment.isBefore(endMoment)) {
      if (currentMoment.isSameOrAfter(startTime) && currentMoment.isSameOrBefore(endTime)) {
        cardStatus = 'active'
      } else if (currentMoment.isAfter(endTime)) {
        cardStatus = 'prev'
      } else if (currentMoment.isBefore(startTime)) {
        cardStatus = 'next'
      }
    } else {
      if (currentMoment.isSameOrAfter(startTime) || currentMoment.isSameOrBefore(endTime)) {
        cardStatus = 'active'
      } else if (currentMoment.isBefore(startTime)) {
        cardStatus = 'next'
      } else if (currentMoment.isAfter(endTime)) {
        cardStatus = 'prev'
      }
    }
  } //function to find if a card is active, prev or next

  allAvailableCards.forEach((card, index) => {
    cardStatusFinder(currentTime, card?.startTime, card?.endTime)

    if (cardStatus === 'active') {
      activeCards.unshift(card)
    } else if (cardStatus === 'prev') {
      previousCards.push(card)
    } else if (cardStatus === 'next') {
      nextCards.push(card)
    }
  }) // pushed available cards into relevant arrays

  const timeLeft = (endTime, currentTime) => {
    const currentMoment = dayjs(currentTime, 'YYYY-MM-DD HH:mm:ss')
    const endMoment = dayjs(endTime, 'YYYY-MM-DD HH:mm:ss')
    let diffInMs

    if (currentMoment.isAfter(endMoment)) {
      endMoment.add(1, 'day')
    }

    diffInMs = endMoment.diff(currentMoment)
    const diffInHours = dayjs.duration(diffInMs).asHours()
    const diffInMinutes = dayjs.duration(diffInMs).asMinutes()
    const diffInSeconds = dayjs.duration(diffInMs).asSeconds()

    let diff
    if (diffInHours >= 1) {
      diff = dayjs.utc(diffInMs).format('HH:mm') + ' hrs'
    } else if (diffInMinutes >= 1) {
      diff = Math.floor(diffInMinutes) + ' minutes'
      if (Math.floor(diffInMinutes) === 1) {
        diff = Math.floor(diffInMinutes) + ' minute'
      }
    } else {
      diff = 'Less than a minute'
    }

    return diff
  } // tells how much time is left in hh:mm format or in minutes

  const toAmPm = (startTime) => {
    const startMoment = dayjs(startTime, 'YYYY-MM-DD HH:mm:ss')
    return startMoment.format('h:mm A')
  } // converts array of hh,mm,ss to 12 hour format

  const previousCard = previousCards.at(-1)
  const prevCardItems = []
  if (previousCard?.heroItem) {
    prevCardItems.push(previousCard.heroItem)
  }
  if (previousCard?.otherItems) {
    prevCardItems.push(...previousCard.otherItems)
  }

  const activeCard = activeCards[0]
  const activeCardItems = []
  if (activeCard?.heroItem) {
    activeCardItems.push(activeCard.heroItem)
  }
  if (activeCard?.otherItems) {
    activeCardItems.push(...activeCard.otherItems)
  }

  const nextCard = nextCards[0]
  const nextCardItems = []
  if (nextCard?.heroItem) {
    nextCardItems.push(nextCard.heroItem)
  }
  if (nextCard?.otherItems) {
    nextCardItems.push(...nextCard.otherItems)
  }
  //pushing items into respective slots

  function checkIfSupported(itemData) {
    return supportedPlayItems.includes(itemData?.type)
  } //checks if card is supported

  let prevCardSupportedItems = prevCardItems.filter(checkIfSupported)
  let activeCardSupportedItems = activeCardItems.filter(checkIfSupported)
  let nextCardSupportedItems = nextCardItems.filter(checkIfSupported)

  prevCardSupportedItems = markCompleteIfPlayed(completionDataMap, prevCardSupportedItems) // also using to check and put into data, what mood was chosen last time
  activeCardSupportedItems = markCompleteIfPlayed(completionDataMap, activeCardSupportedItems)
  nextCardSupportedItems = markCompleteIfPlayed(completionDataMap, nextCardSupportedItems)

  let allActiveCompleted = true
  activeCardSupportedItems?.forEach((item) => {
    if (!item?.completed) {
      allActiveCompleted = false
    }
  })

  const handleCardScroll = () => {
    setCardScrolled(cardScrollRef?.current?.scrollTop)
  } // check and set scroll position from top for cardbodyinside container.

  // useEffect(() => {
  //     let firstIncompleteItemIndex = 0;
  //     for (let i = 0; i < activeCardSupportedItems.length; i++) {
  //         if (!activeCardSupportedItems[i]?.completed) {
  //             firstIncompleteItemIndex = i;
  //             break;
  //         }
  //     }
  //     if (cardScrollRef.current) {
  //         cardScrollRef.current.scroll({
  //             top: 285 * firstIncompleteItemIndex,
  //             behavior: 'smooth',
  //         });
  //     }
  // }, [completionData])
  //scrolling to first incomplete item

  let emptySlotData
  if (Array.isArray(timeSlots)) {
    timeSlots?.forEach((item) => {
      const startTime = item?.timeSlot?.startTime
      const endTime = item?.timeSlot?.endTime
      if (startTime < endTime) {
        if (currentTime.split(' ')[1] >= startTime && currentTime.split(' ')[1] <= endTime) {
          emptySlotData = item?.emptySlotMsg
        }
      } else if (endTime < startTime) {
        if (currentTime.split(' ')[1] >= startTime || currentTime.split(' ')[1] <= endTime) {
          emptySlotData = item?.emptySlotMsg
        }
      }
    })
  } //getting timeslot data and getting empty slot messages from there

  return (
    <DailyPlayContainer play={activeTile === 'play'}>
      <>
        {previousCards.length === 0 && activeCards.length === 0 && nextCards.length === 0 ? (
          <SlotCardsParent>
            <CheatDayCard>
              <CheatDayImage src={restHammock} />
              <BottomTextComponent
                textOne="Today is a"
                textTwo="Cheat Day"
                textThree="Take this day to take out the most in yourself"
              />
            </CheatDayCard>
          </SlotCardsParent>
        ) : (
          <SlotCardsParent>
            {previousCards.length !== 0 && prevCardSupportedItems.length !== 0 && (
              <LeftSideCard>
                <ClosedCardImgAndText>
                  {previousCards.at(-1)?.iconId && (
                    <IconImage src={`${mediaURL}${previousCards.at(-1)?.iconId}`} w={60} />
                  )}
                  <div>Previous</div>
                </ClosedCardImgAndText>

                <DetailedOverview
                  text={
                    chosenDay === '0'
                      ? `${previousCards.at(-1)?.playTitle}`
                      : `${dayjs()?.add(parseInt(chosenDay), 'day')?.format('dddd')} ${
                          previousCards.at(-1)?.slotTitle
                        }`
                  }
                  img={
                    previousCards.at(-1)?.iconId
                      ? `${mediaURL}${previousCards.at(-1)?.iconId}`
                      : null
                  }
                  scoreData={scoreCalculator(completionDataMap, prevCardSupportedItems)}
                />

                <SocialComparison
                  score={scoreCalculator(completionDataMap, prevCardSupportedItems)}
                  items={prevCardSupportedItems}
                />

                <SlotSummary text="Replay" items={prevCardSupportedItems} />
              </LeftSideCard>
            )}
            {nextCards.length !== 0 && nextCardSupportedItems.length !== 0 && (
              <RightSideCard>
                <ClosedCardImgAndText>
                  {nextCards[0]?.iconId && (
                    <IconImage src={`${mediaURL}${nextCards[0]?.iconId}`} w={60} />
                  )}
                  <div>Next</div>
                </ClosedCardImgAndText>

                <DetailedOverview
                  text={
                    chosenDay === '0'
                      ? `${nextCards[0]?.playTitle}`
                      : `${dayjs()?.add(parseInt(chosenDay), 'day')?.format('dddd')} ${
                          nextCards[0]?.slotTitle
                        }`
                  }
                  img={nextCards[0]?.iconId ? `${mediaURL}${nextCards[0]?.iconId}` : null}
                  scoreData={scoreCalculator(completionDataMap, nextCardSupportedItems)}
                  next
                />

                <UnlockingTimeClock text="Unlocks at" time={`${toAmPm(nextCards[0]?.startTime)}`} />

                <SlotSummary text="Coming Up" items={nextCardSupportedItems} next />
              </RightSideCard>
            )}
            {activeCards.length !== 0 && activeCardSupportedItems.length !== 0 ? (
              <ActiveCardContainer>
                <CardHeader style={{ cursor: 'pointer' }} onClick={() => navigate('/leaderboard')}>
                  <ScoreInfo
                    scoreData={scoreCalculator(completionDataMap, activeCardSupportedItems)}
                  />
                  <SlotTime
                    text={
                      chosenDay === '0'
                        ? activeCards[0]?.playTitle
                        : `${dayjs()?.add(parseInt(chosenDay), 'day')?.format('dddd')} ${
                            activeCards[0]?.slotTitle
                          }`
                    }
                    img={`${mediaURL}${activeCards[0]?.iconId}`}
                    haveIcon={activeCards[0]?.iconId}
                  />
                  {chosenDay === '0' ? (
                    <SlotEndsIn
                      text="Closes in"
                      time={
                        activeCards[0]?.timeSlot === 'fullday' && nextCards[0]
                          ? timeLeft(nextCards[0]?.startTime, currentTime)
                          : timeLeft(activeCards[0]?.endTime, currentTime)
                      }
                    />
                  ) : (
                    <div style={{ width: '50px' }}></div>
                  )}
                </CardHeader>

                {allActiveCompleted ? (
                  <CardBody>
                    <CongratulatingCard>
                      <div className="flex justify-between">
                        <div className="flex flex-col">
                          <CongratulatingCardTitle main>
                            {activeCards[0]?.completedSlotMsg?.title || 'Congratulations!'}
                          </CongratulatingCardTitle>

                          <CongratulatingCardTitle>
                            {activeCards[0]?.completedSlotMsg?.subText ||
                              `You have conquered your ${activeCards[0]?.slotTitle} Play`}
                          </CongratulatingCardTitle>
                        </div>

                        <CongratulatingCardMaskot
                          src={
                            activeCards[0]?.completedSlotMsg?.imageId
                              ? `${mediaURL}${activeCards[0]?.completedSlotMsg?.imageId}`
                              : smile_emoji_play
                          }
                        />
                      </div>

                      <SuggestionCard as={Link} to={`/sound`}>
                        <SuggestionCardText>Tap to Listen</SuggestionCardText>

                        <SuggestionCardText main>Relaxing Music</SuggestionCardText>
                      </SuggestionCard>
                    </CongratulatingCard>

                    {activeCardSupportedItems?.map((item, index) => {
                      const itemData = itemDataExtractor(item, setupData)
                      return (
                        <CompletedCardItem
                          key={index}
                          itemData={itemData}
                          slot={activeCards[0]?.slotTitle}
                        />
                      )
                    })}

                    <PreferencesButton onClick={() => setIsDailyPlaySettingsOpen(true)}>
                      <SettingsIcon sx={{ color: 'white', fontSize: 20 }} />
                      Preferences
                    </PreferencesButton>
                  </CardBody>
                ) : (
                  <>
                    <CardBody ref={cardScrollRef} onScroll={handleCardScroll}>
                      {activeCardSupportedItems.map((item, index) => {
                        const itemData = itemDataExtractor(item, setupData)

                        if (itemData?.itemType === 'mental-state-type') {
                          return (
                            <ThreadAndCardContainer key={index}>
                              <ThreadAndFlagContainer>
                                <DotForCard completed={itemData?.completed} />
                                <ThreadForCard completed={itemData?.completed} />
                              </ThreadAndFlagContainer>

                              <CardItemMood
                                key={index}
                                itemData={itemData}
                                slotId={activeCards[0]?.slotTitle}
                                timeSlot={activeCards[0]?.timeSlot}
                                getDailyPlayProgress={getDailyPlayProgress}
                              />
                            </ThreadAndCardContainer>
                          )
                        }

                        return (
                          <ThreadAndCardContainer key={index}>
                            <ThreadAndFlagContainer>
                              <DotForCard completed={itemData?.completed} />
                              <ThreadForCard completed={itemData?.completed} />
                            </ThreadAndFlagContainer>

                            <CardItem
                              key={index}
                              itemData={itemData}
                              slotId={activeCards[0]?.slotTitle}
                            />
                          </ThreadAndCardContainer>
                        )
                      })}

                      <SentinelItem
                        headings={
                          activeCards[0]?.sentinelCard?.titleList?.length !== 0
                            ? activeCards[0]?.sentinelCard?.titleList
                            : ['You are Doing Great !', 'Keep Going']
                        }
                        text={activeCards[0]?.sentinelCard?.subText || 'With Love from Team AUMHUM'}
                        imgId={activeCards[0]?.sentinelCard?.imageId}
                      />

                      {activeCardSupportedItems.length > 2 && cardScrolled === 0 && (
                        <MoreItemsButton>{`+${
                          activeCardSupportedItems.length - 2
                        } More Items`}</MoreItemsButton>
                      )}

                      <PreferencesButton onClick={() => setIsDailyPlaySettingsOpen(true)}>
                        <SettingsIcon sx={{ color: 'white', fontSize: 20 }} />
                        Preferences
                      </PreferencesButton>
                    </CardBody>

                    {/* <CardBodyBlur /> */}
                  </>
                )}
              </ActiveCardContainer>
            ) : (
              <ActiveCardContainer>
                <NoActiveCardItemsContainer>
                  <NoActiveCardItemsPicture
                    src={
                      emptySlotData?.imageId
                        ? `${mediaURL}${emptySlotData?.imageId}`
                        : resting_on_sofa
                    }
                  />
                  <NoActiveCardText>
                    {emptySlotData?.title || 'It is time to Relax'}
                  </NoActiveCardText>
                  <NoActiveCardText small>
                    {emptySlotData?.subText || 'Meanwhile you can'}
                  </NoActiveCardText>
                  <BrowseAppButton onClick={() => navigate(buildWellnessTilePath('sound'), {})}>
                    {emptySlotData?.actionBtnText || 'Browse Music'}
                  </BrowseAppButton>
                  <PreferencesButton
                    style={{ width: '70%', margin: '20px auto' }}
                    onClick={() => setIsDailyPlaySettingsOpen(true)}
                  >
                    <SettingsIcon sx={{ color: 'white', fontSize: 20 }} />
                    Preferences
                  </PreferencesButton>
                </NoActiveCardItemsContainer>
              </ActiveCardContainer>
            )}
          </SlotCardsParent>
        )}
      </>

      {Object.keys(daysData).length > 1 && (
        <StreakComponent
          completionData={completionData}
          chosenDay={chosenDay}
          setChosenDay={setChosenDay}
          daysData={daysData}
          userScoreData={userScoreData}
          profileData={profileData}
        />
      )}

      {dailyPlaySettingsShowingMethod === 'drawer' && (
        <DailyPlaySettingsDrawer
          className="drawer"
          anchor="bottom"
          open={isDailyPlaySettingsOpen}
          transitionDuration={{ enter: 600, exit: 300 }}
        >
          <DailyPlaySettingsComponent
            closeFunction={saveDailyPlaySettings}
            dailyPlayContentTypesSectionWise={dailyPlayContentTypesSectionWise}
            userPlayConfig={userPlayConfig}
            setUserPlayConfig={setUserPlayConfig}
            playTypes={setupData?.metaPlayConfig?.playTypes}
            timeSlotsData={timeSlots}
          />
        </DailyPlaySettingsDrawer>
      )}

      {dailyPlaySettingsShowingMethod === 'modal' && (
        <DailyPlaySettingsModalComponent open={isDailyPlaySettingsOpen}>
          <DailyPlaySettingsComponent
            closeFunction={saveDailyPlaySettings}
            dailyPlayContentTypesSectionWise={dailyPlayContentTypesSectionWise}
            userPlayConfig={userPlayConfig}
            setUserPlayConfig={setUserPlayConfig}
            playTypes={setupData?.metaPlayConfig?.playTypes}
            timeSlotsData={timeSlots}
          />
        </DailyPlaySettingsModalComponent>
      )}
    </DailyPlayContainer>
  )
}

export default DailyPlay

// Card Connectors code:

{
  /* <CardBodyConnectors>
    
    {activeCardSupportedItems.map((item, index) => {
        return <HorizontalItemConnector key={index} propheight={`${142.5 + 75 + index * (285 + 27.78)}px`} />
    })}

    {activeCardSupportedItems.map((item, index) => {
        return <VerticalItemConnector key={index} propheight={`${142.5 + 75 + index * (285 + 27.78)}px`} />  //displayNone={(index === activeCardSupportedItems.length - 1) && 'true'} prop to hide last vertical line
    })}

</CardBodyConnectors> */
}
